import React from 'react'
import DailyTasks from '../../Component/adminComp/DailyTasks'

const AdminDailyTasks = () => {
  return (


      <DailyTasks/>
 
  )
}

export default AdminDailyTasks;